export default "__VITE_ASSET__BIA5Mgkv__"